module.exports = __webpack_public_path__ + "static/img/contant_5.1793d38.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1st/Articles/Article_3/contant_5.jpg
// module id = y992
// module chunks = 0